module.exports = __webpack_public_path__ + "static/media/logos-print-calvario.77b05d6a.jpg";